import React, { PureComponent } from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { fetchConferencia } from '../actions/satActions'
import { Datepicker, Loader } from 'modules/shared'
import { DateTime } from 'luxon'
import Select from 'react-select'
import SatBody from './SatBody'
import SatDetail from './SatDetail'

class Sat extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            filteredCompanies: [],
            dateIni: DateTime.local().minus({ days: 1}).startOf('day').toJSDate(),
            dateEnd: DateTime.local().minus({ days: 1}).toJSDate(),
            detailModal: false,
            modalContent: {}
        }
        this.toggleDetail = this.toggleDetail.bind(this)
        this.filterCompanies = this.filterCompanies.bind(this)
        this.filterDate = this.filterDate.bind(this)
    }

    componentWillMount() {
        this.props.fetchConferencia(this.state.dateIni, this.state.dateEnd)
    }

    filterCompanies(value) {
        let _ids = value.map(v => v.value)
        this.setState({
            filteredCompanies: this.props.satState.postos.filter(p => _ids.includes(p._id)).map(p => p._id)
        })
    }

    filterDate(dates) {
        if (dates.length >= 1 && (DateTime.fromJSDate(this.state.dateIni).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[0]).toFormat('yyyyMMdd') || DateTime.fromJSDate(this.state.dateEnd).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[1]).toFormat('yyyyMMdd'))) {
            if (dates.length === 1)
                this.setState({ dateIni: dates[0], dateEnd: dates[0] })
            else
                this.setState({ dateIni: dates[0], dateEnd: dates[1] })

            if (DateTime.fromJSDate(this.state.dateIni) <= DateTime.fromJSDate(this.state.dateEnd))
                this.props.fetchConferencia(this.state.dateIni, this.state.dateEnd)
        }
    }

    toggleDetail(event) {
        let type = event.currentTarget.getAttribute('data-detail')
        this.setState({
            detailModal: !this.state.detailModal,
            modalContent: type ? { type, emp: parseInt(event.currentTarget.getAttribute('data-emp')), nomeEmpresa: this.props.satState.postos.filter(p => p._id === parseInt(event.currentTarget.getAttribute('data-emp')))[0].nomeEmpresa } : {}
        })
    }

    render() {

        let { loading, postos } = this.props.satState

        if (loading)
            return <Loader />

        postos = postos && postos.length ? postos : []
        const options = postos.map(p => {
            return { value: p._id, label: p.nomeEmpresa }
        })
    
        postos = this.state.filteredCompanies.length ? postos.filter(p => this.state.filteredCompanies.includes(p._id)) : postos

        return (
            <div className="container">

                <div className="row">
                    <div className="col col-sm-4 mt-2">
                        <Select
                            options={options}
                            defaultValue={postos.filter(p => this.state.filteredCompanies.includes(p._id)).map(p => {
                                return { value: p._id, label: p.nomeEmpresa }
                            })}
                            isMulti
                            placeholder="Filtrar empresas..."
                            classNamePrefix="react-select"
                            onChange={this.filterCompanies} 
                        />
                    </div>

                    <div className="col col-sm-4 mt-2">
                        <Datepicker
                            defaultDate={[this.state.dateIni, this.state.dateEnd]}
                            onChange={this.filterDate}
                        />
                    </div>

                    <div className="col mt-2">
                        <button onClick={() => this.props.fetchConferencia(this.state.dateIni, this.state.dateEnd)} className="btn btn-primary btn-sm">
                            <i className="fas fa-sync-alt"></i>
                            Atualizar                        
                        </button>
                    </div>

                </div>

                {postos && postos.length > 0 && <div className="row">
                    <SatBody lista={postos} toggleDetail={this.toggleDetail}/>
                </div>}

                <SatDetail 
                    content={this.state.modalContent} 
                    toggleDetail={this.toggleDetail} 
                    shouldShow={this.state.detailModal}
                    dateIni={this.state.dateIni} 
                    dateEnd={this.state.dateEnd} 
                />

            </div>
        )
    }
}

const mapStateToProps = store => ({ satState: store.satState })
const mapDispatchToProps = dispatch => bindActionCreators({ fetchConferencia }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Sat)
